
import React from 'react';
import { motion, Variant } from 'framer-motion';
import { WeatherCondition } from '@/types/weather';
import { getAnimationVariants } from './utils/animationUtils';
import { getWeatherIcon, getIconSize, IconSize } from './utils/iconUtils';

interface AnimatedWeatherIconProps {
  condition: WeatherCondition;
  size?: IconSize;
  animated?: boolean;
}

/**
 * A component that displays an animated weather icon based on the weather condition
 */
export const AnimatedWeatherIcon: React.FC<AnimatedWeatherIconProps> = ({ 
  condition, 
  size = "lg", 
  animated = false 
}) => {
  const sizeClass = getIconSize(size);
  const variants = getAnimationVariants(condition, animated);
  const icon = getWeatherIcon(condition, sizeClass);

  return (
    <motion.div 
      className="animate-float"
      variants={variants}
      initial="initial"
      animate={animated ? "animate" : "initial"}
      whileHover="hover"
      whileTap={{ scale: 0.95 }}
    >
      {icon}
    </motion.div>
  );
};

export default AnimatedWeatherIcon;
